export function $map(method: string): string {
  return `$${method}`
}
